import {
  REQUEST_PROFILE_TAB_ACTIVITIES,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS,
  REQUEST_PROFILE_TAB_CHATS,
  REQUEST_PROFILE_TAB_DOC_FLOWS,
  REQUEST_PROFILE_TAB_DOCUMENTS,
  REQUEST_PROFILE_TAB_EMAILS,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS,
  REQUEST_PROFILE_TAB_POSTS,
  REQUEST_PROFILE_TAB_RATING,
  REQUEST_PROFILE_TAB_UPDATES,
} from '../RequestProfile.constants'

export const REQUEST_PROFILE_TAB_PERMISSION_KEY = {
  [REQUEST_PROFILE_TAB_ACTIVITIES]: 'can_view_activities',
  [REQUEST_PROFILE_TAB_ATTACHED_REQUESTS]: 'can_view_related_requests',
  [REQUEST_PROFILE_TAB_CHATS]: [
    'can_view_public_chat',
    'can_view_private_chat',
  ],
  [REQUEST_PROFILE_TAB_DOC_FLOWS]: 'can_view_connected_document_staplings',
  [REQUEST_PROFILE_TAB_DOCUMENTS]: 'can_view_documents',
  [REQUEST_PROFILE_TAB_EMAILS]: 'can_view_emails',
  [REQUEST_PROFILE_TAB_INTERNAL_TASKS]: 'can_view_checklists',
  [REQUEST_PROFILE_TAB_POSTS]: 'can_view_posts',
  [REQUEST_PROFILE_TAB_RATING]: 'can_view_rating',
  [REQUEST_PROFILE_TAB_UPDATES]: 'can_view_updates',
}

export const REQUEST_PROFILE_TAB_TITLE_KEY = {
  [REQUEST_PROFILE_TAB_ACTIVITIES]: 'RequestProfileTabs.ActivitiesTabKey',
  [REQUEST_PROFILE_TAB_ATTACHED_REQUESTS]:
    'RequestProfileTabs.AttachedRequestsTabKey',
  [REQUEST_PROFILE_TAB_CHATS]: 'RequestProfileTabs.ChatsTabKey',
  [REQUEST_PROFILE_TAB_DOC_FLOWS]: 'RequestProfileTabs.DocFlowsTabKey',
  [REQUEST_PROFILE_TAB_DOCUMENTS]: 'RequestProfileTabs.DocumentsTabKey',
  [REQUEST_PROFILE_TAB_EMAILS]: 'RequestProfileTabs.EmailsTabKey',
  [REQUEST_PROFILE_TAB_INTERNAL_TASKS]: 'RequestProfile.InternalTasksTabKey',
  [REQUEST_PROFILE_TAB_POSTS]: 'RequestProfileTabs.PostsTabKey',
  [REQUEST_PROFILE_TAB_RATING]: 'RequestProfileTabs.RatingTabKey',
  [REQUEST_PROFILE_TAB_UPDATES]: 'RequestProfileTabs.UpdatesTabKey',
}

export const REQUEST_PROFILE_TABS = [
  REQUEST_PROFILE_TAB_EMAILS,
  REQUEST_PROFILE_TAB_CHATS,
  REQUEST_PROFILE_TAB_ACTIVITIES,
  REQUEST_PROFILE_TAB_DOCUMENTS,
  REQUEST_PROFILE_TAB_POSTS,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS,
  REQUEST_PROFILE_TAB_DOC_FLOWS,
  REQUEST_PROFILE_TAB_RATING,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS,
  REQUEST_PROFILE_TAB_UPDATES,
]

// Tabs the counters endpoint reports a `total` for.
export const REQUEST_PROFILE_TABS_WITH_COUNTERS = [
  REQUEST_PROFILE_TAB_EMAILS,
  REQUEST_PROFILE_TAB_CHATS,
  REQUEST_PROFILE_TAB_ACTIVITIES,
  REQUEST_PROFILE_TAB_DOCUMENTS,
  REQUEST_PROFILE_TAB_POSTS,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS,
  REQUEST_PROFILE_TAB_DOC_FLOWS,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS,
]
